import Gallery from 'react-photo-gallery';
import Carousel, { CarouselStyles, Modal, ModalGateway } from 'react-images';
import React, { useCallback, useState } from 'react';
import GalleryImage from './GalleryImage';
import SlicePhotoGalleryPhotoView from '@utmb/types/view/SlicePhotoGalleryPhotoView';
import { useCloudinary } from '@utmb/design-system/use-cloudinary/UseCloudinary';
import isMobile from '@utmb/utils/is-mobile';

import styles from './gallery.module.scss';

interface GalleryProps {
    photos: SlicePhotoGalleryPhotoView[];
    isSquared?: boolean;
}

const GalleryDS = (props: GalleryProps) => {
    const { photos, isSquared = false } = props;
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const { getImage } = useCloudinary();

    const openLightbox = useCallback((event, { index }) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    }, []);

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const customStyle: CarouselStyles = {
        footerCaption: (base) => ({
            ...base,
            width: '100%',
            padding: '6px',
            textAlign: 'center',
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.4)',
        }),
    };

    const imageRenderer = useCallback(
        ({ index, left, top, key, photo }) => (
            <GalleryImage
                key={key}
                index={index}
                photo={photo}
                left={left}
                top={top}
                setCurrentImage={setCurrentImage}
                setViewerIsOpen={setViewerIsOpen}
                title={photos[index].title}
                isSquared={isSquared}
            />
        ),
        [photos]
    );

    return (
        <div
            className={[styles.gallery, isSquared ? styles.squaredStyle : ''].join(' ')}
            style={{ minHeight: isSquared ? `${Math.round(photos.length / 2) * 150 + 2 * photos.length}px` : 'auto' }}
        >
            <Gallery
                photos={photos
                    .filter((x) => x.picture?.publicId)
                    .map((p) => {
                        return { ...p.picture, src: getImage(p.picture.publicId) };
                    })}
                onClick={openLightbox}
                renderImage={imageRenderer}
                direction={isMobile() ? 'column' : 'row'}
                columns={2}
            />
            <ModalGateway>
                {viewerIsOpen ? (
                    <Modal onClose={closeLightbox}>
                        <Carousel
                            currentIndex={currentImage}
                            views={photos
                                .filter((x) => x.picture?.publicId)
                                .map((x) => ({
                                    ...x.picture,
                                    source: getImage(x.picture.publicId),
                                    caption: x.title,
                                }))}
                            styles={customStyle}
                        />
                    </Modal>
                ) : null}
            </ModalGateway>
        </div>
    );
};

export default GalleryDS;
